module.exports = __webpack_public_path__ + "img/52114126_L.a141d58e.png";